// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'code-search';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.663 10.515a6.749 6.749 0 0 0 12.472-.115 6.75 6.75 0 1 0-12.472.115zm10.694 2.407 4.518 3.953' />
    <path d='M5.625 6.188 3.937 7.875l1.688 1.688m4.5-3.375 1.688 1.687-1.688 1.688M8.438 6.188 7.312 9.563' />
  </g>
);

export const viewBox = '0 0 18 18';
